import React, { useMemo } from "react";

/**
 * VideoAdOverlay Component
 * Displays fullscreen video ad with click-to-dismiss functionality
 */
const VideoAdOverlay = ({
  videoAds,
  currentVideoIndex,
  videoPlayKey,
  onVideoEnded,
  onVideoSkipped,
  onVideoPlay,
  onVideoError,
  videoShownAtRef,
  hasLoggedCurrentPlaybackRef,
}) => {
  // Filter ads to only show fullscreen ads (adFormat === 1)
  const fullscreenAds = useMemo(() => {
    return videoAds.filter((ad) => ad.adFormat === 1);
  }, [videoAds]);

  if (!fullscreenAds.length || currentVideoIndex >= fullscreenAds.length) {
    return null;
  }

  const currentAd = fullscreenAds[currentVideoIndex];

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        cursor: "pointer",
        flexDirection: "column",
      }}
      onClick={onVideoSkipped}
      onTouchStart={onVideoSkipped}
    >
      {currentAd && (
        <>
          <video
            key={`video-${currentVideoIndex}-${videoPlayKey}`}
            autoPlay
            muted
            playsInline
            onClick={onVideoSkipped}
            onTouchStart={onVideoSkipped}
            controls={false}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            onLoadStart={() => {
              console.log("🎬 Video loading:", currentAd?.mediaPath);
            }}
            onCanPlay={() => {
              console.log("▶️ Video ready to play:", currentAd?.mediaPath);
            }}
            onPlay={() => {
              console.log("▶️ Video started playing:", currentAd?.title);
              onVideoPlay();
            }}
            onEnded={() => {
              console.log("✅ Video ended:", currentAd?.title);
              onVideoEnded();
            }}
            onError={(e) => {
              console.error(
                "❌ Video failed to load. Error:",
                e,
                "Path:",
                currentAd?.mediaPath
              );
              onVideoError();
            }}
          >
            <source src={currentAd?.mediaPath} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              textAlign: "center",
              color: "#fff",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              padding: "12px",
              borderRadius: "8px",
              maxWidth: "300px",
            }}
          >
            <p style={{ marginBottom: "8px", fontSize: "14px" }}>
              {currentAd?.title || "Ad"} ({currentVideoIndex + 1}/
              {fullscreenAds.length})
            </p>
            <p style={{ marginBottom: 0, fontSize: "12px" }}>
              Click or tap anywhere to dismiss
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default VideoAdOverlay;